import * as types from "./mutations-types";

export default {
    [types.SET_MONTH](state, month) {
        state.month = month;
    },
    [types.SET_YEAR](state, year) {
        state.year = year;
    }
};